import { TileEntrySubmission } from "../../models/app/Tile";

export const MOCK_EXAMS: TileEntrySubmission[] = [
  {
    "entry_id":37,
    "userID":"23744275",
    "grade":"8.8",
  },
  {
    "entry_id":37,
    "userID":"18298956",
    "grade":"9.2"
  },
  {
    "entry_id":37,
    "userID":"29376337",
    "grade":"6.3",
  },
  {
    "entry_id":37,
    "userID":"52682411",
    "grade":"7.3",
  },
  {
    "entry_id":37,
    "userID":"96955357",
    "grade":"6.5"
  },
  {
    "entry_id":37,
    "userID":"74114284",
    "grade":"9.2",
  },
  {
    "entry_id":37,
    "userID":"32324131",
    "grade":"9.5"
  },
  {
    "entry_id":37,
    "userID":"74886921",
    "grade":"8.8"
  },
  {
    "entry_id":37,
    "userID":"95366984",
    "grade":"8.7"
  },
  {
    "entry_id":37,
    "userID":"23400528",
    "grade":"9.2"
  },
  {
    "entry_id":37,
    "userID":"81888190",
    "grade":"7.3"
  },
  {
    "entry_id":37,
    "userID":"28332183",
    "grade":"7.8"
  },
  {
    "entry_id":37,
    "userID":"35251913",
    "grade":"7.2"
  },
  {
    "entry_id":37,
    "userID":"41393783",
    "grade":"9.5"
  },
  {
    "entry_id":37,
    "userID":"50326251",
    "grade":"9.2"
  },
  {
    "entry_id":37,
    "userID":"35683215",
    "grade":"9"
  },
  {
    "entry_id":37,
    "userID":"38152009",
    "grade":"9.2"
  },
  {
    "entry_id":37,
    "userID":"27817769",
    "grade":"7.8"
  },
  {
    "entry_id":37,
    "userID":"43219917",
    "grade":"8"
  },
  {
    "entry_id":37,
    "userID":"97222205",
    "grade":"7.3"
  },
  {
    "entry_id":37,
    "userID":"66889858",
    "grade":"7.7"
  },
  {
    "entry_id":37,
    "userID":"90434281",
    "grade":"8.2"
  },
  {
    "entry_id":37,
    "userID":"20380320",
    "grade":"9.8"
  },
  {
    "entry_id":37,
    "userID":"95372011",
    "grade":"9"
  },
  {
    "entry_id":37,
    "userID":"46647543",
    "grade":"8"
  },
  {
    "entry_id":37,
    "userID":"22976781",
    "grade":"8.2"
  },
  {
    "entry_id":37,
    "userID":"54264654",
    "grade":"8.5"
  },
  {
    "entry_id":37,
    "userID":"70805720",
    "grade":"5.5"
  },
  {
    "entry_id":37,
    "userID":"41898388",
    "grade":"8"
  },
  {
    "entry_id":37,
    "userID":"41149744",
    "grade":"7.8"
  },
  {
    "entry_id":37,
    "userID":"86899376",
    "grade":"8.7"
  },
  {
    "entry_id":37,
    "userID":"43754947",
    "grade":"7.2"
  },
  {
    "entry_id":37,
    "userID":"20936679",
    "grade":"9.3"
  },
  {
    "entry_id":37,
    "userID":"21276717",
    "grade":"8.5"
  },
  {
    "entry_id":37,
    "userID":"31665008",
    "grade":"7.8"
  },
  {
    "entry_id":37,
    "userID":"53036575",
    "grade":"8.8"
  },
  {
    "entry_id":37,
    "userID":"16967126",
    "grade":"6.3"
  },
  {
    "entry_id":37,
    "userID":"27034712",
    "grade":"7"
  },
  {
    "entry_id":37,
    "userID":"96600883",
    "grade":"8.3"
  },
  {
    "entry_id":37,
    "userID":"24585559",
    "grade":"7.5"
  },
  {
    "entry_id":37,
    "userID":"59540503",
    "grade":"8.2"
  },
  {
    "entry_id":37,
    "userID":"48905367",
    "grade":"6.5"
  },
  {
    "entry_id":37,
    "userID":"48470625",
    "grade":"8"
  },
  {
    "entry_id":37,
    "userID":"76262947",
    "grade":"8.3"
  },
  {
    "entry_id":37,
    "userID":"45844627",
    "grade":"9.3"
  },
  {
    "entry_id":37,
    "userID":"41803722",
    "grade":"8.8"
  },
  {
    "entry_id":37,
    "userID":"42345728",
    "grade":"9.8"
  },
  {
    "entry_id":37,
    "userID":"77161172",
    "grade":"6.5"
  },
  {
    "entry_id":37,
    "userID":"45476233",
    "grade":"8.8"
  },
  {
    "entry_id":37,
    "userID":"46666218",
    "grade":"5.7"
  },
  {
    "entry_id":37,
    "userID":"55249485",
    "grade":"9"
  },
  {
    "entry_id":37,
    "userID":"81005245",
    "grade":"8.3"
  },
  {
    "entry_id":37,
    "userID":"28624178",
    "grade":"7.2"
  },
  {
    "entry_id":37,
    "userID":"55571292",
    "grade":"9.2"
  },
  {
    "entry_id":38,
    "userID":"23744275",
    "grade":"6.8"
  },
  {
    "entry_id":38,
    "userID":"18298956",
    "grade":"7.6"
  },
  {
    "entry_id":38,
    "userID":"29376337",
    "grade":"4.5"
  },
  {
    "entry_id":38,
    "userID":"52682411",
    "grade":"6.2"
  },
  {
    "entry_id":38,
    "userID":"96955357",
    "grade":"6.6"
  },
  {
    "entry_id":38,
    "userID":"74114284",
    "grade":"6"
  },
  {
    "entry_id":38,
    "userID":"32324131",
    "grade":"6.7"
  },
  {
    "entry_id":38,
    "userID":"74886921",
    "grade":"7"
  },
  {
    "entry_id":38,
    "userID":"95366984",
    "grade":"4.2"
  },
  {
    "entry_id":38,
    "userID":"23400528",
    "grade":"6.3"
  },
  {
    "entry_id":38,
    "userID":"81888190",
    "grade":"5.6"
  },
  {
    "entry_id":38,
    "userID":"28332183",
    "grade":"4.7"
  },
  {
    "entry_id":38,
    "userID":"35251913",
    "grade":"5.8"
  },
  {
    "entry_id":38,
    "userID":"41393783",
    "grade":"6.5"
  },
  {
    "entry_id":38,
    "userID":"50326251",
    "grade":"8.2"
  },
  {
    "entry_id":38,
    "userID":"35683215",
    "grade":"4.6"
  },
  {
    "entry_id":38,
    "userID":"38152009",
    "grade":"5"
  },
  {
    "entry_id":38,
    "userID":"27817769",
    "grade":"3.9"
  },
  {
    "entry_id":38,
    "userID":"43219917",
    "grade":"3.6"
  },
  {
    "entry_id":38,
    "userID":"97222205",
    "grade":"5.1"
  },
  {
    "entry_id":38,
    "userID":"66889858",
    "grade":"5.9"
  },
  {
    "entry_id":38,
    "userID":"90434281",
    "grade":"4.7"
  },
  {
    "entry_id":38,
    "userID":"20380320",
    "grade":"6.5"
  },
  {
    "entry_id":38,
    "userID":"95372011",
    "grade":"5.3"
  },
  {
    "entry_id":38,
    "userID":"46647543",
    "grade":"6"
  },
  {
    "entry_id":38,
    "userID":"22976781",
    "grade":"5.7"
  },
  {

    "entry_id":38,
    "userID":"54264654",

    "grade":"6.4"
  },
  {

    "entry_id":38,
    "userID":"70805720",

    "grade":"3"
  },
  {

    "entry_id":38,
    "userID":"41898388",

    "grade":"7.6"
  },
  {

    "entry_id":38,
    "userID":"41149744",

    "grade":"6"
  },
  {

    "entry_id":38,
    "userID":"86899376",

    "grade":"4.7"
  },
  {

    "entry_id":38,
    "userID":"43754947",

    "grade":"3.8"
  },
  {

    "entry_id":38,
    "userID":"20936679",

    "grade":"4.9"
  },
  {

    "entry_id":38,
    "userID":"21276717",

    "grade":"6.8"
  },
  {

    "entry_id":38,
    "userID":"31665008",

    "grade":"6.8"
  },
  {

    "entry_id":38,
    "userID":"53036575",

    "grade":"8.5"
  },
  {

    "entry_id":38,
    "userID":"16967126",

    "grade":"5.6"
  },
  {

    "entry_id":38,
    "userID":"27034712",

    "grade":"6.45"
  },
  {

    "entry_id":38,
    "userID":"96600883",

    "grade":"6.8"
  },
  {

    "entry_id":38,
    "userID":"24585559",

    "grade":"5.7"
  },
  {

    "entry_id":38,
    "userID":"59540503",

    "grade":"4.8"
  },
  {

    "entry_id":38,
    "userID":"48905367",

    "grade":"7.3"
  },
  {

    "entry_id":38,
    "userID":"48470625",

    "grade":"7.1"
  },
  {

    "entry_id":38,
    "userID":"76262947",

    "grade":"6.3"
  },
  {

    "entry_id":38,
    "userID":"45844627",

    "grade":"7.2"
  },
  {

    "entry_id":38,
    "userID":"41803722",

    "grade":"4.2"
  },
  {

    "entry_id":38,
    "userID":"42345728",

    "grade":"8.5"
  },
  {

    "entry_id":38,
    "userID":"77161172",

    "grade":"5.9"
  },
  {

    "entry_id":38,
    "userID":"45476233",

    "grade":"5.6"
  },
  {

    "entry_id":38,
    "userID":"46666218",

    "grade":"5.6"
  },
  {

    "entry_id":38,
    "userID":"55249485",

    "grade":"4.2"
  },
  {

    "entry_id":38,
    "userID":"81005245",

    "grade":"7.1"
  },
  {

    "entry_id":38,
    "userID":"28624178",

    "grade":"4"
  },
  {

    "entry_id":38,
    "userID":"55571292",

    "grade":"7.1"
  },
  {

    "entry_id":39,
    "userID":"23744275",
    "grade":"7.8"
  },
  {

    "entry_id":39,
    "userID":"18298956",

    "grade":"7.4"
  },
  {

    "entry_id":39,
    "userID":"29376337",

    "grade":"7.8"
  },
  {

    "entry_id":39,
    "userID":"52682411",

    "grade":"7.6"
  },
  {

    "entry_id":39,
    "userID":"96955357",

    "grade":"7.6"
  },
  {

    "entry_id":39,
    "userID":"74114284",

    "grade":"7.9"
  },
  {

    "entry_id":39,
    "userID":"32324131",

    "grade":"7.2"
  },
  {

    "entry_id":39,
    "userID":"74886921",

    "grade":"6.8"
  },
  {

    "entry_id":39,
    "userID":"95366984",

    "grade":"8.7"
  },
  {

    "entry_id":39,
    "userID":"23400528",

    "grade":"9.4"
  },
  {

    "entry_id":39,
    "userID":"81888190",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"28332183",

    "grade":"6.8"
  },
  {

    "entry_id":39,
    "userID":"35251913",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"41393783",

    "grade":"7.2"
  },
  {

    "entry_id":39,
    "userID":"50326251",

    "grade":"7.8"
  },
  {

    "entry_id":39,
    "userID":"35683215",

    "grade":"7.4"
  },
  {

    "entry_id":39,
    "userID":"38152009",

    "grade":"7.2"
  },
  {

    "entry_id":39,
    "userID":"27817769",

    "grade":"7.9"
  },
  {

    "entry_id":39,
    "userID":"43219917",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"97222205",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"66889858",

    "grade":"7.2"
  },
  {

    "entry_id":39,
    "userID":"90434281",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"20380320",

    "grade":"8.9"
  },
  {

    "entry_id":39,
    "userID":"46647543",

    "grade":"8.1"
  },
  {

    "entry_id":39,
    "userID":"22976781",

    "grade":"7.4"
  },
  {

    "entry_id":39,
    "userID":"54264654",

    "grade":"7.9"
  },
  {

    "entry_id":39,
    "userID":"70805720",

    "grade":"8.7"
  },
  {

    "entry_id":39,
    "userID":"41898388",

    "grade":"9.4"
  },
  {

    "entry_id":39,
    "userID":"41149744",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"86899376",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"43754947",

    "grade":"7.4"
  },
  {

    "entry_id":39,
    "userID":"20936679",

    "grade":"7.8"
  },
  {

    "entry_id":39,
    "userID":"21276717",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"31665008",

    "grade":"7.6"
  },
  {

    "entry_id":39,
    "userID":"53036575",

    "grade":"7.6"
  },
  {

    "entry_id":39,
    "userID":"16967126",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"27034712",

    "grade":"8.1"
  },
  {

    "entry_id":39,
    "userID":"96600883",

    "grade":"9.1"
  },
  {

    "entry_id":39,
    "userID":"24585559",

    "grade":"9.1"
  },
  {

    "entry_id":39,
    "userID":"59540503",

    "grade":"6.6"
  },
  {

    "entry_id":39,
    "userID":"48905367",

    "grade":"8.7"
  },
  {

    "entry_id":39,
    "userID":"48470625",

    "grade":"8.1"
  },
  {

    "entry_id":39,
    "userID":"76262947",

    "grade":"6.6"
  },
  {

    "entry_id":39,
    "userID":"45844627",

    "grade":"8.5"
  },
  {

    "entry_id":39,
    "userID":"41803722",

    "grade":"7.8"
  },
  {

    "entry_id":39,
    "userID":"42345728",

    "grade":"8.5"
  },
  {

    "entry_id":39,
    "userID":"77161172",

    "grade":"6.3"
  },
  {

    "entry_id":39,
    "userID":"45476233",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"46666218",

    "grade":"7"
  },
  {

    "entry_id":39,
    "userID":"55249485",

    "grade":"9.3"
  },
  {

    "entry_id":39,
    "userID":"81005245",

    "grade":"7.2"
  },
  {

    "entry_id":39,
    "userID":"28624178",

    "grade":"7.9"
  },
  {

    "entry_id":39,
    "userID":"55571292",

    "grade":"8.3"
  },
  {

    "entry_id":40,
    "userID":"23744275",

    "grade":"7.3"
  },
  {

    "entry_id":40,
    "userID":"18298956",

    "grade":"6"
  },
  {

    "entry_id":40,
    "userID":"29376337",

    "grade":"5.2"
  },
  {

    "entry_id":40,
    "userID":"52682411",

    "grade":"4.7"
  },
  {

    "entry_id":40,
    "userID":"96955357",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"74114284",

    "grade":"5.4"
  },
  {

    "entry_id":40,
    "userID":"32324131",

    "grade":"6.4"
  },
  {

    "entry_id":40,
    "userID":"74886921",

    "grade":"5.8"
  },
  {

    "entry_id":40,
    "userID":"95366984",

    "grade":"5.1"
  },
  {

    "entry_id":40,
    "userID":"23400528",

    "grade":"7.3"
  },
  {

    "entry_id":40,
    "userID":"81888190",

    "grade":"5.8"
  },
  {

    "entry_id":40,
    "userID":"28332183",

    "grade":"2.6"
  },
  {

    "entry_id":40,
    "userID":"35251913",

    "grade":"7.2"
  },
  {

    "entry_id":40,
    "userID":"41393783",

    "grade":"4.1"
  },
  {

    "entry_id":40,
    "userID":"50326251",

    "grade":"6.9"
  },
  {

    "entry_id":40,
    "userID":"35683215",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"38152009",

    "grade":"6.1"
  },
  {

    "entry_id":40,
    "userID":"27817769",

    "grade":"6.3"
  },
  {

    "entry_id":40,
    "userID":"43219917",

    "grade":"5.5"
  },
  {

    "entry_id":40,
    "userID":"97222205",

    "grade":"6"
  },
  {

    "entry_id":40,
    "userID":"66889858",

    "grade":"6.7"
  },
  {

    "entry_id":40,
    "userID":"90434281",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"20380320",

    "grade":"7.6"
  },
  {

    "entry_id":40,
    "userID":"95372011",

    "grade":"4.3"
  },
  {

    "entry_id":40,
    "userID":"46647543",

    "grade":"7.1"
  },
  {

    "entry_id":40,
    "userID":"22976781",

    "grade":"4.3"
  },
  {

    "entry_id":40,
    "userID":"54264654",

    "grade":"4.8"
  },
  {

    "entry_id":40,
    "userID":"70805720",

    "grade":"3.4"
  },
  {

    "entry_id":40,
    "userID":"41898388",

    "grade":"7.5"
  },
  {

    "entry_id":40,
    "userID":"41149744",

    "grade":"4.8"
  },
  {

    "entry_id":40,
    "userID":"86899376",

    "grade":"6.6"
  },
  {

    "entry_id":40,
    "userID":"43754947",

    "grade":"5.5"
  },
  {

    "entry_id":40,
    "userID":"20936679",

    "grade":"4.8"
  },
  {

    "entry_id":40,
    "userID":"21276717",

    "grade":"6.6"
  },
  {

    "entry_id":40,
    "userID":"31665008",

    "grade":"6.1"
  },
  {

    "entry_id":40,
    "userID":"53036575",

    "grade":"7"
  },
  {

    "entry_id":40,
    "userID":"16967126",

    "grade":"6.4"
  },
  {

    "entry_id":40,
    "userID":"27034712",

    "grade":"6.5"
  },
  {

    "entry_id":40,
    "userID":"96600883",

    "grade":"6.7"
  },
  {

    "entry_id":40,
    "userID":"24585559",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"59540503",

    "grade":"4.8"
  },
  {

    "entry_id":40,
    "userID":"48905367",

    "grade":"7.5"
  },
  {

    "entry_id":40,
    "userID":"48470625",

    "grade":"6.9"
  },
  {

    "entry_id":40,
    "userID":"76262947",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"45844627",

    "grade":"6.2"
  },
  {

    "entry_id":40,
    "userID":"41803722",

    "grade":"5.2"
  },
  {

    "entry_id":40,
    "userID":"42345728",

    "grade":"6.7"
  },
  {

    "entry_id":40,
    "userID":"77161172",

    "grade":"6.4"
  },
  {

    "entry_id":40,
    "userID":"45476233",

    "grade":"5.9"
  },
  {

    "entry_id":40,
    "userID":"46666218",

    "grade":"5.7"
  },
  {

    "entry_id":40,
    "userID":"55249485",

    "grade":"6.5"
  },
  {

    "entry_id":40,
    "userID":"81005245",

    "grade":"5.8"
  },
  {

    "entry_id":40,
    "userID":"28624178",

    "grade":"5.2"
  },
  {

    "entry_id":40,
    "userID":"55571292",

    "grade":"6.2"
  }
]
